import React from "react";
import { debugLogPages } from "../../app/helpers/debugHelper";
import L2LeftContainerFilter from "./L2LeftContainerFilter";
import L2RightContainer from "./L2RightContainer";

const L2ContainerInformation = ({
  searchTextState,
  catalogsToFilter,
  setCatalogsToFilter,
  moduleSelected,
  setModuleSelected,
  catalogCiiuLevel1Selected,
  setCatalogCiiuLevel1Selected,
  indicatorsToFilter,
  setIndicatorsToFilter,
  itemsPerPage,
  setItemsPerPage,
  groupVisionSelected,
  setGroupVisionSelected,
  concernSelected,
  setConcernSelected
}) => {

  debugLogPages(':: L2ContainerInformation');

  return (
    <div className="row InfoBusqueda">
      <div className="col-md-2">

        <L2LeftContainerFilter
          searchTextState={searchTextState}
          catalogsToFilter={catalogsToFilter}
          setCatalogsToFilter={setCatalogsToFilter}
          moduleSelected={moduleSelected}
          setModuleSelected={setModuleSelected}
          catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
          setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
          indicatorsToFilter={indicatorsToFilter}
          setIndicatorsToFilter={setIndicatorsToFilter}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          groupVisionSelected={groupVisionSelected}
          setGroupVisionSelected={setGroupVisionSelected}
          concernSelected={concernSelected}
          setConcernSelected={setConcernSelected}
        />

      </div>
      <div className="col-md-10">

        <L2RightContainer
          searchTextState={searchTextState}
          catalogsToFilter={catalogsToFilter}
          moduleSelected={moduleSelected}
          catalogCiiuLevel1Selected={catalogCiiuLevel1Selected}
          setCatalogCiiuLevel1Selected={setCatalogCiiuLevel1Selected}
          indicatorsToFilter={indicatorsToFilter}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          groupVisionSelected={groupVisionSelected}
          setGroupVisionSelected={setGroupVisionSelected}
          concernSelected={concernSelected}
          setConcernSelected={setConcernSelected}
        />

      </div>
    </div>
  );
};

export default L2ContainerInformation;
